export default Object.freeze({
  urgency: 'urgency',
  immediate: 'immediate',
  appointment: 'appointment',
  fromRepairer: 'fromRepairer',
});
